import { Box, Tooltip, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import SilverBadge from "../../assets/images/badges/silver.svg";
import GoldBadge from "../../assets/images/badges/gold.svg";
import EliteBadge from "../../assets/images/badges/elite.svg";
import PlatinumBadge from "../../assets/images/badges/platinum.svg";
import BronzeBadge from "../../assets/images/badges/bronze.svg";

/**
 * Agency Badge medallion (feature: agency_commission_badges).
 *
 * Uses the same medallion styling as the existing partner badge so the two
 * look identical to the user.
 *
 * Silver and Gold reuse the existing partner badge artwork; Elite has its own.
 */
export const agencyBadgeImage = (name) => {
  const key = String(name || "").toLowerCase();
  if (key.includes("elite")) return EliteBadge;
  if (key.includes("gold")) return GoldBadge;
  if (key.includes("silver")) return SilverBadge;
  if (key.includes("platinum")) return PlatinumBadge;
  if (key.includes("bronze")) return BronzeBadge;
  return null;
};

export default function AgencyBadgeChip({
  name,
  percentage,
  size = "small",
  showPercentage = true,
  showName = false,
  tooltip,
}) {
  const lightMode = useSelector((state) => state.mode?.lightMode);

  if (!name) return null;

  const image = agencyBadgeImage(name);
  const px = size === "small" ? 32 : 56;

  // No artwork yet (Elite) — render nothing rather than a wrong medallion.
  if (!image && !showName && !showPercentage) return null;

  const medallion = !image ? null : (
    <img
      style={{
        cursor: tooltip ? "pointer" : "default",
        borderRadius: "50%",
        boxShadow: "0 0 4px rgba(0,0,0,0.25)",
        background: lightMode ? "#ffffff" : "#000000",
        flexShrink: 0,
      }}
      width={`${px}px`}
      height={`${px}px`}
      src={image}
      alt={`${name} agency badge`}
    />
  );

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: size === "small" ? "0.4rem" : "0.6rem",
        whiteSpace: "nowrap",
      }}
    >
      {medallion &&
        (tooltip ? (
          <Tooltip title={tooltip} placement="top" arrow>
            {medallion}
          </Tooltip>
        ) : (
          medallion
        ))}

      {showName && (
        <Typography
          component="span"
          sx={{
            fontSize: size === "small" ? "13px" : "18px",
            fontWeight: 700,
            textTransform: "capitalize",
          }}
        >
          {name}
        </Typography>
      )}

      {showPercentage && percentage != null && (
        <Typography
          component="span"
          sx={{
            fontSize: size === "small" ? "13px" : "18px",
            fontWeight: 600,
            opacity: 0.85,
          }}
        >
          {percentage}%
        </Typography>
      )}
    </Box>
  );
}
